module.exports = {
    "dismiss": `Zignoruj`
};


//# sourceMappingURL=pl-PL.main.js.map
